const _excluded = ["attribute", "limit", "className", "itemClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import c from 'classnames';
import ReactDomServer from 'react-dom/server';
import { useMenu } from 'react-instantsearch';
import { FormSelect } from '@uncinc/uncinc-react-kitchen-sink';
const SearchFacetMenuSelect = props => {
  const {
      attribute,
      limit = 100,
      className,
      itemClassName
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const {
    items,
    canRefine,
    refine
  } = useMenu(_objectSpread(_objectSpread({}, props), {}, {
    limit,
    showMore: false
  }));
  const classNames = c('Searchkit__Facet__MenuSelect', className);
  const itemClassNames = c('Searchkit__Facet__MenuSelect__item', itemClassName);
  const options = useMemo(() => items.map(item => ({
    value: item.value,
    label: ReactDomServer.renderToString(/*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count))),
    disabled: item.count === 0
  })), [items]);
  const defaultValue = useMemo(() => {
    const currentOption = items.find(item => item.isRefined);
    return currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
  }, [items]);
  if (!canRefine) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormSelect, _extends({}, restProps, {
    fieldName: "menu_".concat(attribute),
    options: options,
    defaultValue: defaultValue,
    multiple: false,
    wrapperClassName: classNames,
    className: itemClassNames,
    onChange: value => {
      refine(value);
    }
  }));
};
export default SearchFacetMenuSelect;